module.exports = __webpack_public_path__ + "img/20200609_115431.a5fc9495.jpg";